module.exports = __webpack_public_path__ + "img/college4.128ef303.png";